

const anteriorPaperDoll         = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_PaperDoll.png');
const anteriorAbdomen           = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Abdomen.png');
const anteriorChest             = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Chest.png');
const anteriorFace              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Face.png');
const anteriorEars              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Ears.png');
const anteriorNose              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Nose.png');
const anteriorMouth              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Mouth.png');
const anteriorEyes              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Eyes.png');
const anteriorGenitalia         = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Genitalia.png');
const anteriorScalp             = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Scalp.png');
const anteriorLeftFoot          = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Left_Foot.png');
const anteriorLeftHand          = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Left_Hand.png');
const anteriorLowerLeftArm      = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_LowerLeft_Arm.png');
const anteriorLowerLeftLeg      = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_LowerLeft_Leg.png');
const anteriorLowerRightArm     = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_LowerRight_Arm.png');
const anteriorLowerRightLeg     = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_LowerRight_Leg.png');
const anteriorNeck              = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Neck.png');
const anteriorRightFoot         = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Right_Foot.png');
const anteriorRightHand         = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_Right_Hand.png');
const anteriorUpperLeftArm      = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_UpperLeft_Arm.png');
const anteriorUpperLeftLeg      = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_UpperLeft_Leg.png');
const anteriorUpperRightArm     = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_UpperRight_Arm.png');
const anteriorUpperRightLeg     = require('../assets/PaperDoll/Female_Anterior/Female_Anterior_UpperRight_Leg.png');

const posteriorPaperDoll        = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_PaperDoll.png');
const posteriorButtocks         = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Buttocks.png');
const posteriorScalp            = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Scalp.png');
const posteriorLeftFoot         = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Left_Foot.png');
const posteriorLeftHand         = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Left_Hand.png');
const posteriorLowerBack        = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Lower_Back.png');
const posteriorLowerLeftArm     = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_LowerLeft_Arm.png');
const posteriorLowerLeftLeg     = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_LowerLeft_Leg.png');
const posteriorLowerRightArm    = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_LowerRight_Arm.png');
const posteriorLowerRightLeg    = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_LowerRight_Leg.png');
const posteriorNeck             = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Neck.png');
const posteriorRightFoot        = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Right_Foot.png');
const posteriorRightHand        = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Right_Hand.png');
const posteriorUpperBack        = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_Upper_Back.png');
const posteriorUpperLeftArm     = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_UpperLeft_Arm.png');
const posteriorUpperLeftLeg     = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_UpperLeft_Leg.png');
const posteriorUpperRightArm    = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_UpperRight_Arm.png');
const posteriorUpperRightLeg    = require('../assets/PaperDoll/Female_Posterior/Female_Posterior_UpperRight_Leg.png');


const anterior = {
  paperDoll: {
    styles: {
      width: '305px',
      height: '578px',
    },
    image: anteriorPaperDoll,
  },
  locations: {
    HEAD: {
      styles: {
        left: '129.8px',
        top: '3px',
        width: '46px',
      },
      tooltipPlacement: 'left',
      image: anteriorScalp,
    },
    FACE: {
      styles: {
        left: '129.2px',
        top: '19.3px',
        width: '47.2px',
        zIndex: 2,
      },
      tooltipPlacement: 'left',
      image: anteriorFace,
      disableArrow: true,
    },
    NOSE: {
      styles: {
        left: '147px',
        top: '45px',
        width: '11px',
        zIndex: 2,
      },
      tooltipPlacement: 'left',
      image: anteriorNose,
      disableArrow: true,
      isDark: true,
    },
    MOUTH: {
      styles: {
        left: '145px',
        top: '55px',
        width: '16px',
        zIndex: 2,
        height: '15px',
      },
      tooltipPlacement: 'left',
      image: anteriorMouth,
      disableArrow: true,
      isDark: true,
    },
    EYES: {
      styles: {
        left: '136px',
        top: '28px',
        width: '34px',
        zIndex: 2,
      },
      tooltipPlacement: 'left',
      image: anteriorEyes,
      disableArrow: true,
      isDark: true,
    },
    EARS: {
      styles: {
        left: '123.5px',
        top: '36px',
        width: '59px',
      },
      tooltipPlacement: 'left',
      image: anteriorEars,
      disableArrow: true,
    },
    NECK: { 
      styles: {
        left: '114px',
        top: '71.9px',
        width: '77.5px',
      },
      tooltipPlacement: 'left',
      image: anteriorNeck,
    },
    CHEST: {
      styles: {
        left: '104.2px',
        top: '103px',
        width: '96.9px',
      },
      tooltipPlacement: 'right',
      image: anteriorChest,
    },
    RIGHT_ARM_UPPER: {
      styles: {
        left: '59px',
        top: '100.6px',
        width: '64.8px',
      },
      tooltipPlacement: 'left',
      image: anteriorUpperRightArm,
    },
    RIGHT_ARM_LOWER: {
      styles: {
        left: '29.4px',
        top: '199.5px',
        width: '48.6px',
      },
      tooltipPlacement: 'left',
      image: anteriorLowerRightArm,
    },
    RIGHT_HAND: {
      styles: {
        left: '3.2px',
        top: '266.5px',
        width: '41.5px',
      },
      tooltipPlacement: 'left',
      image: anteriorRightHand,
    },
    LEFT_ARM_UPPER: {
      styles: {
        left: '181.5px',
        top: '100.6px',
        width: '64.8px',
      },
      tooltipPlacement: 'right',
      image: anteriorUpperLeftArm,
    },
    LEFT_ARM_LOWER: {
      styles: {
        left: '226.6px',
        top: '199.9px',
        width: '48.6px',
      },
      tooltipPlacement: 'right',
      image: anteriorLowerLeftArm,
    },
    LEFT_HAND: {
      styles: {
        left: '260px',
        top: '267.4px',
        width: '41.5px',
      },
      tooltipPlacement: 'right',
      image: anteriorLeftHand,
    },
    ABDOMEN: {
      styles: {
        left: '104.7px',
        top: '162.2px',
        width: '95.4px',
      },
      tooltipPlacement: 'right',
      image: anteriorAbdomen,
    },
    GENITALIA: {
      styles: {
        left: '94.2px',
        top: '245.4px',
        width: '116.5px',
      },
      tooltipPlacement: 'right',
      image: anteriorGenitalia,
    },
    RIGHT_LEG_UPPER: {
      styles: {
        left: '95.7px',
        top: '322px',
        width: '51.7px',
      },
      tooltipPlacement: 'left',
      image: anteriorUpperRightLeg,
    },
    RIGHT_LEG_LOWER: {
      styles: {
        left: '117.7px',
        top: '448px',
        width: '28.9px',
      },
      tooltipPlacement: 'left',
      image: anteriorLowerRightLeg,
    },
    RIGHT_FOOT: {
      styles: {
        left: '122px',
        top: '551px',
        width: '27.5px',
      },
      tooltipPlacement: 'left',
      image: anteriorRightFoot,
    },
    LEFT_LEG_UPPER: {
      styles: {
        left: '157.3px',
        top: '322px',
        width: '51.7px',
      },
      tooltipPlacement: 'right',
      image: anteriorUpperLeftLeg,
    },
    LEFT_LEG_LOWER: {
      styles: {
        left: '158.2px',
        top: '448px',
        width: '28.9px',
      },
      tooltipPlacement: 'right',
      image: anteriorLowerLeftLeg,
    },
    LEFT_FOOT: {
      styles: {
        left: '155px',
        top: '551px',
        width: '27.5px',
      },
      tooltipPlacement: 'right',
      image: anteriorLeftFoot,
    },
  }
};

const posterior = {
  paperDoll: {
    styles: {
      width: '305px',
      height: '578px',
    },
    image: posteriorPaperDoll,
  },
  locations: {
    HEAD: {
      styles: {
        left: '123.9px',
        top: '1.4px',
        width: '57.6px',
      },
      tooltipPlacement: 'right',
      image: posteriorScalp,
    },
    NECK: {
      styles: {
        left: '126px',
        top: '54.7px',
        width: '53.5px',
      },
      tooltipPlacement: 'right',
      image: posteriorNeck,
    },
    RIGHT_ARM_UPPER: {
      styles: {
        left: '202.8px',
        top: '104.8px',
        width: '43.9px',
      },
      tooltipPlacement: 'right',
      image: posteriorUpperRightArm,
    },
    RIGHT_ARM_LOWER: {
      styles: {
        left: '228.4px',
        top: '201.3px',
        width: '48.8px',
      },
      tooltipPlacement: 'right',
      image: posteriorLowerRightArm,
    },
    RIGHT_HAND: {
      styles: {
        left: '261.6px',
        top: '268.7px',
        width: '41.7px',
      },
      tooltipPlacement: 'right',
      image: posteriorRightHand,
    },
    LEFT_ARM_UPPER: {
      styles: {
        left: '58.1px',
        top: '105.1px',
        width: '43.9px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperLeftArm,
    },
    LEFT_ARM_LOWER: {
      styles: {
        left: '28.5px',
        top: '201.3px',
        width: '48.8px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerLeftArm,
    },
    LEFT_HAND: {
      styles: {
        left: '2.1px',
        top: '268.8px',
        width: '41.7px',
      },
      tooltipPlacement: 'left',
      image: posteriorLeftHand,
    },
    BACK_UPPER: {
      styles: {
        left: '102px',
        top: '96.3px',
        width: '100.9px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperBack,
    },
    BACK_LOWER: {
      styles: {
        left: '109px',
        top: '180.3px',
        width: '87px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerBack,
    },
    BUTTOCKS: {
      styles: {
        left: '94px',
        top: '234px',
        width: '117px',
      },
      tooltipPlacement: 'left',
      image: posteriorButtocks,
    },
    RIGHT_LEG_UPPER: {
      styles: {
        left: '157.9px',
        top: '340px',
        width: '46px',
      },
      tooltipPlacement: 'right',
      image: posteriorUpperRightLeg,
    },
    RIGHT_LEG_LOWER: {
      styles: {
        left: '158.3px',
        top: '450px',
        width: '29px',
      },
      tooltipPlacement: 'right',
      image: posteriorLowerRightLeg,
    },
    RIGHT_FOOT: {
      styles: {
        left: '157px',
        top: '552px',
        width: '21px',
      },
      tooltipPlacement: 'right',
      image: posteriorRightFoot,
    },
    LEFT_LEG_UPPER: {
      styles: {
        left: '100.3px',
        top: '340px',
        width: '47px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperLeftLeg,
    },
    LEFT_LEG_LOWER: {
      styles: {
        left: '117.8px',
        top: '450px',
        width: '29px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerLeftLeg,
    },
    LEFT_FOOT: {
      styles: {
        left: '127px',
        top: '552px',
        width: '21px',
      },
      tooltipPlacement: 'left',
      image: posteriorLeftFoot,
    },
  }
};

export default {
  anterior,
  posterior,
};

